import React, {
  createContext,
  useContext,
  useEffect,
  useState,
} from 'react';
import { DesktopNavbar } from './DesktopNavbar/DesktopNavbar';

const NavbarContext = createContext({});

export const Navbar = (props) => {
  const {
    carMenu,
    healthMenu,
    partnerMenu,
    articleMenu,
    serviceMenu,
    offerMenu,
    guestMenu,
    authenticatedMenu,
    isAuthenticated,
    activeMenu,
    loginAction,
    logoutAction
  } = props;

  let mainNav;
  let primaryNav;
  let secondaryNav;

  const [isDesktop, setIsDesktop] = useState(false);

  if (isDesktop) {
    primaryNav = carMenu.concat(healthMenu).concat(partnerMenu).concat(articleMenu).concat(offerMenu);

    if(isAuthenticated && authenticatedMenu) {
      secondaryNav = serviceMenu.concat(authenticatedMenu);

      mainNav = carMenu.concat(healthMenu).concat(partnerMenu).concat(articleMenu).concat(offerMenu).concat(serviceMenu).concat(authenticatedMenu);

    } else if(!isAuthenticated && guestMenu) {
      secondaryNav = serviceMenu.concat(guestMenu);
      
      mainNav = carMenu.concat(healthMenu).concat(partnerMenu).concat(articleMenu).concat(offerMenu).concat(serviceMenu).concat(guestMenu);
    }

  } else {
    if(isAuthenticated && authenticatedMenu) {
      primaryNav = offerMenu.concat(authenticatedMenu).concat(carMenu).concat(healthMenu).concat(partnerMenu).concat(articleMenu).concat(serviceMenu);

      mainNav = carMenu.concat(healthMenu).concat(partnerMenu).concat(articleMenu).concat(offerMenu).concat(serviceMenu).concat(authenticatedMenu);

    } else {
      primaryNav = offerMenu.concat(guestMenu).concat(carMenu).concat(healthMenu).concat(partnerMenu).concat(articleMenu).concat(serviceMenu);

      mainNav = carMenu.concat(healthMenu).concat(partnerMenu).concat(articleMenu).concat(offerMenu).concat(serviceMenu).concat(guestMenu);
    }
  }

  const activeLinks = getActiveMenuLinks(mainNav, activeMenu);

  useEffect(() => {
    const resizeHandler = () => {
      const mobileBreakpoint = window.matchMedia('(max-width: 1199px)');
      const desktopBreakpoint = window.matchMedia('(min-width: 1200px)');

      if (mobileBreakpoint.matches) {
        setIsDesktop(false);

      } else if (desktopBreakpoint.matches) {
        setIsDesktop(true);
      }
    };

    resizeHandler();

    window.addEventListener('resize', resizeHandler);

    return () => {
      window.removeEventListener('resize', resizeHandler);
    };
  }, []);

  return (
    <NavbarContext.Provider
      value={{
        ...props,
        primaryNav,
        secondaryNav,
        activeLinks,
        loginAction: loginAction,
        logoutAction: logoutAction
      }}
    >
      <DesktopNavbar
        isDesktop={isDesktop}
      />
    </NavbarContext.Provider>
  );
};

function getActiveMenuLinks(
  menu,
  activeMenuLink) {
  let activeMenus = [];

  activeMenuLink &&
    menu.forEach((menu) => {
      if (menu.link === activeMenuLink) {
        activeMenus.push(menu.link);
        return;
      }

      if (menu.childItems && Array.isArray(menu.childItems)) {
        const subMenu = getActiveMenuLinks(menu.childItems, activeMenuLink);
        if (subMenu.length) {
          activeMenus = activeMenus.concat(subMenu);
          activeMenus.push(menu.link);
          return;
        }
      }
    });
  return activeMenus;
}

export const useNavbarContext = () => useContext(NavbarContext);
